import React from "react";
import { NavLink, Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignJustify,
  faCube,
  faComments,
  faChartBar,
  faBookOpen,
  faPencilAlt,
  faProjectDiagram,
} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as SuperbioLogo } from "../images/superbio-logo.svg";
import SuperbioLogoBottom from "../images/superbio-logo-bottom.png";

import "./Navbar.css";

const useStyles = makeStyles({
  root: {
    margin: 0,
    width: "100%",
    height: "7vh",
    backgroundColor: "#005691",
    borderBottom: "5px solid #FF7E67",
    "& > .MuiBox-root:hover": {
      textDecoration: "underline",
      textDecorationColor: "#FF7E67",
      textUnderlinePosition: "under",
      cursor: "pointer",
    },
  },
});

const Navbar = () => {
  const classes = useStyles();
  return (
    <>
      <Box
        color="white"
        className={classes.root}
        display="flex"
        alignItems="center"
        flexDirection="row-reverse"
        p={1}
        m={1}
      >
        <Box p={1}>ACCOUNT</Box>
        <Box p={1}>DOCUMENTATION</Box>
        <Box p={1}>SUPPORT</Box>
        <Box flexGrow={1} p={1}>
          <SuperbioLogo style={{ marginTop: "10px" }} />
        </Box>
      </Box>

      <div className="side-navbar">
        <Box className="side-navbar-box" display="flex" flexDirection="column">
          <NavLink
            className="navlink"
            exact
            to="/"
            activeStyle={{
              backgroundColor: "#ffe7e3",
              color: "#07689F",
              fontWeight: "bold",
            }}
          >
            <Box p={1}>
              <div>
                <FontAwesomeIcon icon={faAlignJustify} />
                <p>Dashboard</p>
              </div>
            </Box>
          </NavLink>

          <Box p={1}>
            <div>
              <FontAwesomeIcon icon={faChartBar} />
              <p>Datasets</p>
            </div>
          </Box>

          <NavLink
            className="navlink"
            to="/methods"
            activeStyle={{
              backgroundColor: "#ffe7e3",
              color: "#07689F",
              fontWeight: "bold",
            }}
          >
            <Box p={1}>
              <div>
                <FontAwesomeIcon icon={faCube} />
                <p>Methods</p>
              </div>
            </Box>
          </NavLink>

          <Box p={1}>
            <div>
              <FontAwesomeIcon icon={faProjectDiagram} />

              <p>Projects</p>
            </div>
          </Box>
          <Box p={1}>
            <div>
              <FontAwesomeIcon icon={faBookOpen} />
              <p>Research</p>
            </div>
          </Box>

          <Box p={1}>
            <div>
              <FontAwesomeIcon icon={faPencilAlt} />
              <p>Tutorials</p>
            </div>
          </Box>

          <Box p={1}>
            <div>
              <FontAwesomeIcon icon={faComments} />
              <p>Discussion</p>
            </div>
          </Box>
        </Box>
        <img
          className="side-bar-logo"
          src={SuperbioLogoBottom}
          alt="superbioLogoBottom"
        />
      </div>
    </>
  );
};

export default Navbar;
